import { Box, Button, Notification } from '@codeparva/ui-components-library';
import { Form, Formik } from 'formik';
import React from 'react';
import { UserFlowTypes } from '../..';
import { signUpFormSchema } from '../../components/formValidationSchema';
import { UserFlowError } from '../../components/UserFlowError';
import { MyPasswordField, MyTextField } from './SignUpFormFields';
export const SignUpForm = ({
  emailId,
  CreatePassword,
}: UserFlowTypes.TCreateAccount) => {
  const [error, setError] = React.useState<any>();
  const [hasError, setHasError] = React.useState(false);

  const [notification, setNotification] = React.useState(false);
  const submitButtonHandler = (
    values: UserFlowTypes.TSignUpValues,
    resetForm: any
  ) => {
    CreatePassword(values.newPassword, setNotification, setError, setHasError);
    resetForm();
  };

  return (
    <>
      <Formik
        initialValues={{
          userName: emailId,
          newPassword: '',
          confirmPassword: '',
        }}
        validationSchema={signUpFormSchema}
        onSubmit={(values, { resetForm }) => {
          submitButtonHandler(values, resetForm);
        }}
      >
        {({ dirty, isValid }) => {
          return (
            <div>
              <div>
                {notification && (
                  <div className="notificationSection">
                    <Notification className="notificationColor">
                      Sign up successful.
                      <button
                        className="delete"
                        onClick={() => setNotification(false)}
                      ></button>
                    </Notification>
                  </div>
                )}
                <Box className="boxPasswordPadding">
                  <div>
                    <Form>
                      <div className="uneditableSection is-editable">
                        <MyTextField
                          label="Username"
                          type="text"
                          name="userName"
                          readOnly
                        />
                        <div className="overlaySection"></div>
                      </div>
                      <div>
                        <MyPasswordField
                          label="Password"
                          name="newPassword"
                          placeholder="Enter New Password"
                        />
                      </div>
                      <div>
                        <MyPasswordField
                          label="Confirm Password"
                          name="confirmPassword"
                          placeholder="Enter Confirm Password"
                        />
                      </div>
                      {UserFlowError(hasError, error)}

                      <div className="ctaButton">
                        <Button
                          className="signUpBtn"
                          disabled={!dirty || !isValid}
                        >
                          Create Account
                        </Button>
                      </div>
                    </Form>
                  </div>
                </Box>
              </div>
            </div>
          );
        }}
      </Formik>
    </>
  );
};
